import { useState, useEffect } from 'react';
import { testimonials } from '@/mocks/homeData';

const testimonialImages = [
  'https://readdy.ai/api/search-image?query=Stylish%20man%20in%20cream%20knit%20sweater%20leaning%20against%20exposed%20brick%20wall%20in%20sunlit%20loft%20space%20genuine%20warm%20smile%20natural%20afternoon%20light%20streaming%20through%20large%20industrial%20windows%20editorial%20portrait%20photography&width=800&height=960&seq=testimonial-img-v2-0&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Confident%20woman%20in%20white%20linen%20blazer%20sitting%20on%20modern%20minimalist%20sofa%20with%20laptop%20and%20sneakers%20nearby%20soft%20diffused%20studio%20lighting%20professional%20yet%20relaxed%20editorial%20portrait%20photography&width=800&height=960&seq=testimonial-img-v2-1&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Young%20man%20in%20casual%20denim%20jacket%20standing%20in%20trendy%20coffee%20shop%20with%20exposed%20concrete%20walls%20and%20hanging%20plants%20warm%20ambient%20lighting%20authentic%20candid%20moment%20editorial%20lifestyle%20portrait&width=800&height=960&seq=testimonial-img-v2-2&orientation=portrait',
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials[current];

  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative min-h-[300px] lg:min-h-[480px] overflow-hidden">
              <img
                src={testimonialImages[current]}
                alt="Superbuy Spreadsheet community member"
                title="Superbuy Spreadsheet - Community Review"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/30 to-transparent lg:bg-gradient-to-r lg:from-foreground-900/50 lg:to-transparent"></div>
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center px-8 py-10 md:px-16 md:py-14">
              <div className="text-accent-300 text-6xl md:text-7xl font-heading leading-none mb-6 opacity-60">
                &ldquo;
              </div>
              <p className="text-lg md:text-xl text-background-50/90 leading-relaxed mb-8 font-light">
                {t.quote}
              </p>
              <div className="mb-8">
                <p className="text-base font-semibold text-background-50">{t.name}</p>
                <p className="text-sm text-background-50/50">{t.title}</p>
              </div>

              <div className="flex items-center gap-3">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrent(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                      idx === current
                        ? 'bg-accent-400 w-8'
                        : 'bg-background-50/30 hover:bg-background-50/50'
                    }`}
                    aria-label={`Review ${idx + 1}`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}